import { combineReducers } from 'redux-immutablejs';

import globalReducer from './global';
import appealsReducer from './appeals';
import docketsReducer from './dockets';
import dashboardReducer from './dashboard';
import waitingRoomReducer from './waitingRoom';
import appealsPanelReducer from './appealsPanel';
import agentDocketsReducer from './agent';
import workCaseReducer from './workCase';

export default combineReducers({
  global: globalReducer,
  appeals: appealsReducer,
  dockets: docketsReducer,
  dashboard: dashboardReducer,
  waitingRoom: waitingRoomReducer,
  appealsPanel: appealsPanelReducer,
  agentDockets: agentDocketsReducer,
  workCase: workCaseReducer,
});
